<template>
  <Head title="Pathway Mapping Template Editor" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <pathway-mapping-template-editor 
            :columns="columns" 
            :integrations="integrations" 
            :source="source" 
            :datablend-subtypes="datablendSubtypes" 
            :dataset-subtypes="datasetSubtypes"
          ></pathway-mapping-template-editor>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  columns: Array,
  integrations: Array,
  source: String,
  datablendSubtypes: Array,
  datasetSubtypes: Array
});
</script>

